import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/mapaIN/step2';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { TypeFournitures } from '../models/TypeFournitures';
@Component({
  selector: 'app-type-fournitures',
  templateUrl: './type-fournitures.component.html'
})
export class TypeFournituresComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeFournitures';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() marcheFournitures: TypeFournitures;

  public step2 = new Step2();

  radioButtonValue;
  radioButtonCtrlName;
  achat = RadioCheckBoxEnum.achatValue;
  creditBail = RadioCheckBoxEnum.creditBailValue;
  location = RadioCheckBoxEnum.locationValue;
  locationVente = RadioCheckBoxEnum.locationVenteValue;

  constructor() { }

  public ngOnInit() {
    if (this.marcheFournitures.achat === RadioCheckBoxEnum.emptyValue){
      this.radioButtonValue = this.achat;
    } else if (this.marcheFournitures.creditBail  === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.creditBail;
    } else if (this.marcheFournitures.location  === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.location;
    } else if (this.marcheFournitures.locationVente  === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.locationVente;
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_locationVente';
  }
    
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

